<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, 0.9); margin-top: 200px">
      <v-container class="site-padding" id="aboutActionSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">o akcji</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-text doctors-container">
          <v-flex xs12 md12 class="text-xs-left">
            <span class="doctors-container--sections"
              >Szanowni Państwo, Drogie Koleżanki i Koledzy,</span
            >
            <div>
              Przed nami X edycja akcji POLSCY OKULIŚCI KONTRA JASKRA. 
              To inicjatywa Polskiego Towarzystwa Okulistycznego i lekarzy okulistów z całej Polski, 
              która ma na celu podniesienie świadomości społeczeństwa na temat jaskry oraz zwiększenie 
              jej wykrywalności we wczesnych stadiach zaawansowania, a tym samym uratowanie wzroku 
              osób nieświadomych swojej choroby. 
            </div>

            <div class="mt-3">
              Co możecie Państwo zrobić w ramach tej akcji społecznej? Mogą Państwo 
              włączyć się w tę inicjatywę udostępniając poradnię okulistyczną i wykonywać badania 
              przesiewowe w kierunku jaskry u zgłaszających się pacjentów. Diagnostyka przesiewowa 
              obejmuje badanie dna oka, pomiar ciśnienia wewnątrzgałkowego i grubości rogówki 
              oraz wywiad z osobą, która nie korzystała z wizyty u okulisty przynajmniej 
              rok i u której wcześniej nie zdiagnozowano tej choroby.
            </div>

            <div class="mt-3 doctors-container--sections">
              BADANIA W RAMACH X EDYCJI KAMPANII POLSCY OKULIŚCI KONTRA JASKRA ODBYWAJĄ SIĘ W DNIACH 8-14 MARCA. 
            </div>

            <!--            <div class="pt-4 pb-4 text-xs-center">-->
            <!--              <span class="doctors-container&#45;&#45;sections">Zapraszamy na  transmisję live konferencji prasowej: </span>-->
            <!--            </div>-->

            <!--            <v-flex id="video" xs12 class="pt-4 text-xs-center">-->
            <!--              <div class="videoWrapper" style="display: flex; justify-content: center;">-->
            <!--                <iframe src="//iframe.dacast.com/b/142411/c/544128" width="990" height="557"-->
            <!--                        frameborder="0" scrolling="no" allow="autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen-->
            <!--                        msallowfullscreen></iframe>-->
            <!--              </div>-->
            <!--            </v-flex>-->
            <!--            <sponsors-only-slider></sponsors-only-slider>-->

            <!--            <div class="pt-4 pb-4">-->
            <!--              <span>Zapraszamy Państwa do wzięcia udziału w</span>-->
            <!--              <span class="doctors-container&#45;&#45;sections text-capitalize">Polskim Forum Jaskry,</span>-->
            <!--              <span> które odbędzie się w dniu 6 marca 2021 r.</span>-->
            <!--              <a class="doctors-container&#45;&#45;sections" href="https://polskieforumjaskry.net4doctor.online/" target="_blank">Dowiedz się więcej  </a>-->
            <!--            </div>-->
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-padding" id="whyWorthSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">
              dlaczego warto?
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="my-text doctors-container">
          <v-flex xs12 class="text-xs-left">
            <div>
              Udział w akcji to nie tylko działanie na rzecz propagowania
              zdrowia, lecz także
              <span class="doctors-container--sections"
                >doskonała forma promocji dla lekarzy.</span
              >
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-padding" id="institutionSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="patients-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header patients-container--header pt-4">
              Sukcesy poprzednich edycji Polscy Okuliści Kontra Jaskra 2017-2025:
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-2">
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <span
                      style="font-size: 2.6rem; line-height: 1; font-weight: 700; color: #fff"
                    >
                      20 tys.
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="patients-container--sections">przebadanych</span>
                    <span class="patients-container--sections">Polaków</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <span
                      style="font-size: 2.6rem; font-weight: 700; color: #fff"
                    >
                      40%
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="patients-container--sections">Pacjentów skierowanych</span>
                    <span class="patients-container--sections">do dalszej diagnostyki</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <span
                      style="font-size: 2.6rem; font-weight: 700; color: #fff"
                    >
                      400
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="patients-container--sections">gabinetów</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="patients-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <span
                      style="font-size: 2.6rem; line-height: 1; font-weight: 700; color: #fff"
                    >
                      30,5 mln
                    </span>
                  </v-avatar>
                  <div class="patients-container--download-text">
                    <span class="ban2"></span>
                    <span
                      class="patients-container--sections patients-container--sections-blue"
                      >odbiorców akcji edukacyjnej</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <!--      <v-container class="site-padding" id="institutionSection">-->
      <!--        <v-layout align-center justify-center row wrap class="patients-container">-->
      <!--          <v-flex xs12 class="text-xs-left">-->
      <!--            <h1 class="my-header patients-container&#45;&#45;header pt-4">lista gabinetów z roku bieżącego na dzień {{ new-->
      <!--              Date().toLocaleDateString() }}</h1>-->
      <!--            <div class="sparator-container pt-4">-->
      <!--              <div class="sparator-rectangle"></div>-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--        </v-layout>-->

      <!--        <v-layout row wrap class="mt-2">-->
      <!--          <v-flex xs12 md6 lg3 class="mb-3">-->
      <!--            <v-layout>-->
      <!--              <v-flex>-->
      <!--                <div class="patients-container&#45;&#45;download">-->
      <!--                  <v-avatar :size="100" color="rgb(164, 22, 17)">-->
      <!--                          <span-->
      <!--                            style="font-size: 2.6rem; font-weight: 700; color: #fff;"-->
      <!--                          >{{ institutions_number_now }}</span>-->
      <!--                  </v-avatar>-->
      <!--                  <div class="patients-container&#45;&#45;download-text">-->
      <!--                    <span class="ban2">Zarejestrowanych</span>-->
      <!--                    <span class="patients-container&#45;&#45;sections">GABINETÓW</span>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </v-flex>-->
      <!--            </v-layout>-->
      <!--          </v-flex>-->
      <!--          <v-flex xs12 md6 lg3 class="mb-3">-->
      <!--            <v-layout>-->
      <!--              <v-flex>-->
      <!--                <div class="patients-container&#45;&#45;download">-->
      <!--                  <v-avatar :size="100" color="rgb(164, 22, 17)">-->
      <!--                          <span-->
      <!--                            style="font-size: 2.6rem; font-weight: 700; color: #fff;"-->
      <!--                          >{{ cities_number_now }}</span>-->
      <!--                  </v-avatar>-->
      <!--                  <div class="patients-container&#45;&#45;download-text">-->
      <!--                    <span class="patients-container&#45;&#45;sections">MIAST</span>-->
      <!--                    <span class="ban2">na terenie całej Polski</span>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </v-flex>-->
      <!--            </v-layout>-->
      <!--          </v-flex>-->
      <!--          <v-flex xs12 md6 lg3 class="mb-3">-->
      <!--            <v-layout>-->
      <!--              <v-flex>-->
      <!--                <div class="patients-container&#45;&#45;download">-->
      <!--                  <v-avatar :size="100" color="rgb(164, 22, 17)">-->
      <!--                          <span-->
      <!--                            style="font-size: 2.6rem; font-weight: 700; color: #fff;"-->
      <!--                          >{{ states_number_now }}</span>-->
      <!--                  </v-avatar>-->
      <!--                  <div class="patients-container&#45;&#45;download-text">-->
      <!--                    <span class="patients-container&#45;&#45;sections">WOJEWÓDZTW</span>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </v-flex>-->
      <!--            </v-layout>-->
      <!--          </v-flex>-->
      <!--          <v-flex xs12 md6 lg3 class="mb-3">-->
      <!--            <v-layout>-->
      <!--              <v-flex>-->
      <!--                <div class="patients-container&#45;&#45;download">-->
      <!--                  <v-avatar :size="100" color="rgb(39, 82, 113)">-->
      <!--                          <span-->
      <!--                            style="font-size: 2.6rem; font-weight: 700; color: #fff;"-->
      <!--                          >{{ patients_number_now }}</span>-->
      <!--                  </v-avatar>-->
      <!--                  <div class="patients-container&#45;&#45;download-text">-->
      <!--                    <span class="ban2">Dostępnych miejsc dla</span>-->
      <!--                    <span-->
      <!--                      class="patients-container&#45;&#45;sections patients-container&#45;&#45;sections-blue"-->
      <!--                    >PACJENTÓW</span>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </v-flex>-->
      <!--            </v-layout>-->
      <!--          </v-flex>-->
      <!--        </v-layout>-->
      <!--      </v-container>-->

      <v-container class="site-padding" id="registerSection">
        <v-layout row class="mb-3">
          <v-flex class="xs12 sm6">
            <router-link
              :to="{ name: 'Register' }"
              title=""
              class="doctors-container--download"
            >
              <my-button
                title="Zgłoś gabinet"
                text="<span>Zgłoś gabinet&nbsp;&nbsp;</span>"
                customClass="doctor rect-x1"
              />
            </router-link>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="my-text doctors-container">
          <v-flex xs12 class="text-xs-left">
            <!--            <div>-->
            <!--              <span>Przyłącz się do akcji</span>-->
            <!--              <span-->
            <!--                class="doctors-container&#45;&#45;sections text-capitalize"-->
            <!--              >Polscy Okuliści Kontra Jaskra</span>-->
            <!--              <span>i odbierz* bezpłatne materiały informacyjne!</span>-->
            <!--            </div>-->
            <div class="pt-3">
              <h2 class="doctors-container--sections text-uppercase">
                Wystarczą 4 proste kroki:
              </h2>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-2">
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="doctors-container--download">
                  <router-link
                    :to="{ name: 'Register' }"
                    title="WYPEŁNIJ formularz do dnia 2 marca 2026"
                    class="doctors-container--download"
                  >
                    <v-avatar :size="100" color="rgb(39, 82, 113)">
                      <img
                        src="/static/images/Krok1.svg"
                        alt
                        style="height: 50%; border-radius: 0"
                      />
                    </v-avatar>
                    <div class="doctors-container--download-text">
                      <span class="doctors-container--sections">WYPEŁNIJ</span>
                      <span class="ban2"
                        >formularz do dnia<br />2 marca 2026</span
                      >
                    </div>
                  </router-link>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="doctors-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <img
                      src="/static/images/Krok2.svg"
                      alt
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="doctors-container--download-text">
                    <span class="doctors-container--sections">WYDRUKUJ</span>
                    <span class="ban2"
                      >potwierdzenie otrzymane na&nbsp;e-mail</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="doctors-container--download">
                  <v-avatar :size="100" color="rgb(39, 82, 113)">
                    <img
                      src="/static/images/Krok3.svg"
                      alt
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="doctors-container--download-text">
                    <span class="doctors-container--sections"
                      >ODEŚLIJ SKAN</span
                    >
                    <span class="ban2"
                      >dokumentów opatrzony pieczątką gabinetu</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6 lg3 class="mb-3">
            <v-layout>
              <v-flex>
                <div class="doctors-container--download">
                  <v-avatar :size="100" color="rgb(164, 22, 17)">
                    <img
                      src="/static/images/Krok4.svg"
                      alt
                      style="height: 50%; border-radius: 0"
                    />
                  </v-avatar>
                  <div class="doctors-container--download-text">
                    <span
                      class="doctors-container--sections"
                      style="color: rgb(164, 22, 17)"
                      >ODBIERZ</span
                    >
                    <span class="ban2"
                      >materiały: projekt plakatu i&nbsp;ankiety</span
                    >
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container v-if="isRegisterButtonShown()">
        <v-layout row class="mt-3">
          <v-flex
            class="xs12 sm6"
            @mouseover="hover = true"
            @mouseleave="hover = false"
          >
            <my-button
              toName="Register"
              title="Zgłoś gabinet"
              text="<span>Zgłoś <br>gabinet</span>"
              customClass="doctor rect-x1"
            />
          </v-flex>
        </v-layout>
      </v-container>

      <Countdown
        :date="time"
        v-if="time && isRegisterButtonShown()"
      ></Countdown>

      <!--      <v-container class="site-padding" id="registerSection">-->
      <!--            <v-layout row wrap class="doctors-container">-->
      <!--              <v-flex xs12 class="my-text text-xs-left">-->
      <!--                <div>-->
      <!--                  <span>* Specjalny pakiet startowy (materiały drukowane) wyślemy na adres wskazany w formularzu. Materiały zostały umieszczone również poniżej:</span>-->
      <!--                </div>-->
      <!--              </v-flex>-->
      <!--            </v-layout>-->
      <!--      </v-container>-->

      <!-- <v-container class="site-padding" id="downloadSection">-->
      <!--        <v-layout row wrap class="doctors-container">-->
      <!--          <v-flex xs12 class="text-xs-left">-->
      <!--            <h1 class="my-header doctors-container&#45;&#45;header pt-4">materiały do pobrania</h1>-->
      <!--            <div class="sparator-container pt-4">-->
      <!--              <div class="sparator-rectangle"></div>-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--        </v-layout>-->
      <!--        <v-layout row wrap class="pb-3" v-if="isDownload">-->
      <!--          <v-flex xs12 md4 class="text-xs-left">-->
      <!--            <div class="banner pt-2">-->
      <!--              <div class="wrapper">-->
      <!--                <div class="text-container px-2 py-2">-->
      <!--                  <a href="./../../static/pdf/Plakat2021.pdf?u=2" target="_blank" class="doctors-container&#45;&#45;download" @click="storeDownloadItem('plakat')">-->
      <!--                    <v-avatar-->
      <!--                      :size="100"-->
      <!--                      color="rgb(39, 82, 113)"-->
      <!--                    >-->
      <!--                      <img src="/static/images/poster.svg" alt="" style="height: 50%; border-radius: 0">-->
      <!--                    </v-avatar>-->
      <!--                    <div class="doctors-container&#45;&#45;download-text">-->
      <!--                      <span class="ban2">Pobierz</span>-->
      <!--                      <span class="doctors-container&#45;&#45;sections">plakat</span>-->
      <!--                    </div>-->
      <!--                  </a>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--          <v-flex xs12 md4 class="text-xs-left">-->
      <!--            <div class="banner pt-2">-->
      <!--              <div class="wrapper">-->
      <!--                <div class="text-container px-2 py-2">-->
      <!--                  <a href="./../../static/pdf/ulotka.pdf?u=2" target="_blank" class="doctors-container&#45;&#45;download" @click="storeDownloadItem('ulotka')">-->
      <!--                    <v-avatar-->
      <!--                      :size="100"-->
      <!--                      color="rgb(39, 82, 113)"-->
      <!--                    >-->
      <!--                      <img src="/static/images/flyer.svg" alt="" style="height: 50%; border-radius: 0">-->
      <!--                    </v-avatar>-->
      <!--                    <div class="doctors-container&#45;&#45;download-text">-->
      <!--                      <span class="ban2">Pobierz</span>-->
      <!--                      <span class="doctors-container&#45;&#45;sections">ulotkę</span>-->
      <!--                    </div>-->
      <!--                  </a>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--          <v-flex xs12 md4 class="text-xs-left">-->
      <!--            <div class="banner pt-2">-->
      <!--              <div class="wrapper">-->
      <!--                <div class="text-container px-2 py-2">-->
      <!--                  <a href="./../../static/pdf/Ankieta2021.pdf" target="_blank" class="doctors-container&#45;&#45;download" @click="storeDownloadItem('ankieta')">-->
      <!--                    <v-avatar-->
      <!--                      :size="100"-->
      <!--                      color="rgb(39, 82, 113)"-->
      <!--                    >-->
      <!--                      <img src="/static/images/survey.svg" alt="" style="height: 50%; border-radius: 0">-->
      <!--                    </v-avatar>-->
      <!--                    <div class="doctors-container&#45;&#45;download-text">-->
      <!--                      <span class="ban2">Pobierz</span>-->
      <!--                      <span class="doctors-container&#45;&#45;sections">ankietę</span>-->
      <!--                    </div>-->
      <!--                  </a>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </v-flex>-->

      <!--        </v-layout>-->
      <!--        <v-flex xs12 class="text-xs-left" v-if="!isDownload">-->
      <!--          <h2 class="doctors-container&#45;&#45;sections">Materiały do pobrania wkrótce.</h2>-->
      <!--        </v-flex>-->
      <!--      </v-container>-->

      <!--
            <v-container class="site-padding" id="polishGluacomaSection">
              <v-layout row wrap class="doctors-container">
                <v-flex xs12 class="text-xs-left">
                  <h1 class="my-header doctors-container--header pt-4">polskie forum jaskry</h1>
                  <div class="sparator-container pt-4">
                    <div class="sparator-rectangle"></div>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="doctors-container">
                <v-flex xs12 class="my-text text-xs-left">
                  <div>
                    <span
                      class="doctors-container--sections text-capitalize"
                    >Polskie Towarzystwo Okulistyczne</span>
                    <span>zaprasza na konferencję naukową</span>
                    <span class="doctors-container--sections text-capitalize">"Polskie Forum Jaskry",</span>
                    <span>na którym zostaną poruszone aktualne tematy związane z jaskrą - "cichym złodziejem wzroku". Konferencja odbędzie się w dniu 7 marca 2020 roku w</span>
                    <span class="doctors-container--sections">Warszawie.</span>
                    <span>Wydarzenie poprzedza rozpoczynający się 8-go marca</span>
                    <span class="doctors-container--sections text-capitalize">"Światowy Tydzień Jaskry"</span>
                    <span>- międzynarodowa inicjatywa lekarzy okulistów mająca na celu podniesienie świadomości społeczeństwa na temat jaskry oraz zwiększenie jej wykrywalności we wczesnych stadiach zaawansowania.</span>
                  </div>
                  <div class="pt-2">
                    <span>Rejestracja zostanie uruchomiona 1 Stycznia 2020 r.</span>
                  </div>
                  <div class="pt-2">
                    <span>Wszystkim uczestnikom, którzy wezmą udział w wydarzeniu przysługiwać będą</span>
                    <span class="doctors-container--sections text-uppercase">PUNKTY EDUKACYJNE.</span>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container>
              <v-layout row class="mt-3">
                 <v-flex class="xs12 sm6">
                   <my-button
                   toName="Transmission"
                  title="Oglądaj transmisję online "
                  text="<span>Oglądaj transmisję online </span>"
                  customClass="doctor rect-x1"
                />
                 </v-flex>
              </v-layout>
            </v-container>-->

      <!--       <v-container class="site-padding">-->
      <!--      <v-layout row wrap class="pb-3">-->
      <!--       <v-flex xs12 md4 class="text-xs-left">-->
      <!--                    <div class="banner pt-2">-->
      <!--                      <div class="wrapper">-->
      <!--                        <div class="text-container px-2 py-2">-->
      <!--                          <router-link :to="{ name: 'ForumProgram' }" class="doctors-container&#45;&#45;download">-->
      <!--                            <v-avatar-->
      <!--                              :size="100"-->
      <!--                              color="rgb(39, 82, 113)"-->
      <!--                            >-->
      <!--                              <img src="/static/images/download.svg" alt="" style="height: 50%; border-radius: 0">-->
      <!--                            </v-avatar>-->
      <!--                            <div class="doctors-container&#45;&#45;download-text">-->
      <!--                              <span class="doctors-container&#45;&#45;sections">zobacz szczegółowy PROGRAM</span>-->
      <!--                              <span class="ban2">Polskiego Forum Jaskry 2020</span>-->
      <!--                            </div>-->
      <!--                          </router-link>-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--      </v-flex>-->

      <!--     <v-flex xs12 md4 class="text-xs-left py-1" v-if="showForum()">-->
      <!--                      <div class="banner pt-2">-->
      <!--                          <div class="wrapper">-->
      <!--                              <div class="text-container px-2 py-2">-->
      <!--                                <a href="http://pto.com.pl/pfj" class="doctors-container&#45;&#45;download">-->
      <!--                                  <v-avatar-->
      <!--                                    :size="100"-->
      <!--                                    color="rgb(164, 22, 17)"-->
      <!--                                  >-->
      <!--                                    <img src="/static/images/watch.svg" alt="" style="height: 50%; border-radius: 0">-->
      <!--                                  </v-avatar>-->
      <!--                                  <div class="doctors-container&#45;&#45;download-text">-->
      <!--                                    <span class="doctors-container&#45;&#45;sections text-uppercase" style="color: rgb(164, 22, 17)">Oglądaj na żywo</span>-->
      <!--                                    <span class="ban2">relację z Polskiego Forum Jaskry 2020 na stronie PTO.COM.PL</span>-->
      <!--                                  </div>-->
      <!--                                </a>-->
      <!--                              </div>-->
      <!--                          </div>-->
      <!--                      </div>-->
      <!--      </v-flex>-->
      <!--     </v-layout>-->
      <!--      </v-container>-->

      <v-container class="site-padding" id="faqSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">faq</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="my-text doctors-container mb-3">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">1. Jak zgłosić gabinet?</h3>
            <span>Wejdź na stronę</span>
            <router-link
              :to="{ name: 'Register' }"
              class="doctors-container--links"
              >https://www.tydzienjaskry.pl/rejestracja-gabinetu
            </router-link>
            <span>
              i zgłoś gabinet w trzech krokach. Wypełnij wszystkie pola
              formularza i zarejestruj placówkę. Odbierz maila, który wysłaliśmy
              na adres podany podczas rejestracji i wydrukuj potwierdzenie.
              Odeślij skan dokumentu opatrzony pieczątką gabinetu na adres
              e-mail:</span
            >
            <a
              href="mailto:tydzienjaskry@pto.com.pl"
              class="doctors-container--links"
              >tydzienjaskry@pto.com.pl</a
            ><span
              >. Twoje zgłoszenie po naszej weryfikacji pojawi się na liście
              gabinetów.</span
            >
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-text doctors-container mb-3">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">
              2. W JAKI SPOSÓB MOŻESZ ODEBRAĆ MATERIAŁY INFORMACYJNE?
            </h3>
            <span>
              Materiały do druku: ankiety oraz plakaty, będą dostępne do
              pobrania pod linkiem przesłanym na adres e-mail podany w
              formularzu zgłoszeniowym.
            </span>
            <!--            <span>Specjalny pakiet startowy wyślemy na adres podany w formularzu, jeżeli zgłosisz i potwierdzisz udział placówki do 28. lutego 2021 r. Materiały można pobrać również samodzielnie pod adresem:-->
            <!--                          <span-->
            <!--                            @click="scrollToSection('#downloadSection')"-->
            <!--                            class="doctors-container&#45;&#45;links"-->
            <!--                          >www.tydzienjaskry.pl/dla-lekarza</span>.</span>-->
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-text doctors-container mb-3">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">
              3. DLACZEGO NALEŻY PODAĆ GODZINY PRZYJĘĆ W FORMULARZU?
            </h3>
            <span
              >Uzupełnienie godzin przyjęć zminimalizuje ryzyko odesłania
              pacjentów bez badania. Będą oni mogli zapisać się na wizytę
              telefonicznie na wskazane przez placówkę dzień i godzinę.</span
            >
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-text doctors-container mb-3">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">
              4. CZY LEKARZ PO WYKRYCIU JASKRY MOŻE PRZEPISAĆ KROPLE?
            </h3>
            <span>Tak.</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-text doctors-container mb-3">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">
              5. Co zrobić z&nbsp;wypełnionymi ankietami?
            </h3>
            <div>
              Wypełnione ankiety prosimy przesłać pocztą na adres Sekretariatu Zarządu PTO:
            </div>
            <div class="pt-3">
              Sekretariat Polskiego Towarzystwa Okulistycznego
            </div>
            <div>Katedra Okulistyki Wydziału Nauk Medycznych w Katowicach</div>
            <div>Śląski Uniwersytet Medyczny w Katowicach</div>
            <div>ul. Ceglana 35</div>
            <div>40-514 Katowice</div>
            <div>tel.: <a href="tel:570960004">570 960 004</a></div>
            <div>
              lub w&nbsp;formie elektronicznej (skan dokumentu) na adres e-mail:
              <a href="mailto:pto@pto.com.pl" class="doctors-container--links"
                >pto@pto.com.pl.</a
              >
            </div>
          </v-flex>
        </v-layout>
        <!--        <v-layout row wrap class="my-text doctors-container">-->
        <!--          <v-flex xs12 class="text-xs-left">-->
        <!--            faq-->
        <!--            <h3 class="doctors-container&#45;&#45;sections">7. Do kiedy są przyjmowane zgłoszenia gabinetów?</h3>-->
        <!--            <div>-->
        <!--              Rejestracja gabinetów trwa do-->
        <!--              <span class="doctors-container&#45;&#45;sections text-lowercase">6 marca 2019 r.</span>-->
        <!--            </div>-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->
      </v-container>

      <v-container class="site-padding" id="regulationSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">REGULAMIN</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pb-3">
          <v-flex xs12 class="text-xs-left">
            <div class="banner pt-2">
              <div class="wrapper">
                <div class="text-container px-2 py-2">
                  <router-link
                    :to="{ name: 'Regulations' }"
                    class="doctors-container--download"
                  >
                    <v-avatar :size="100" color="rgb(39, 82, 113)">
                      <img
                        src="/static/images/download.svg"
                        alt=""
                        style="height: 50%; border-radius: 0"
                      />
                    </v-avatar>
                    <div class="doctors-container--download-text">
                      <span class="doctors-container--sections"
                        >Zobacz REGULAMIN</span
                      >
                      <span class="ban2"
                        >akcji Polscy Okuliści Kontra Jaskra 2026</span
                      >
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-bottom-padding" id="contactSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">kontakt</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="doctors-container my-text">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">
              Jeśli masz pytania, skontaktuj się z nami!
            </h3>
          </v-flex>
        </v-layout>

        <v-form
          ref="form"
          id="needs-validation"
          v-model="valid"
          lazy-validation
          class="pt-3"
        >
          <v-container>
            <v-layout
              align-baseline
              justify-center
              row
              wrap
              class="register-form"
            >
              <v-flex xs12 md6 class="text-xs-left px-md-3 px-2">
                <v-text-field
                  class="register-form--noShadow"
                  label="Imię i Nazwisko"
                  solo
                  v-model="form.name"
                  :rules="nameRules"
                ></v-text-field>
                <v-text-field
                  class="register-form--noShadow"
                  label="Telefon"
                  solo
                  v-model="form.phone"
                  mask="###########"
                  :rules="nameRules"
                ></v-text-field>
                <v-text-field
                  class="register-form--noShadow"
                  label="E-mail"
                  solo
                  v-model="form.email"
                  :rules="emailRules"
                ></v-text-field>
                <v-textarea
                  class="register-form--noShadow register-form--spacing"
                  label="Wiadomość"
                  solo
                  full-width
                  rows="12"
                  no-resize
                  v-model="form.message"
                  :rules="nameRules"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-left px-md-3 px-4">
                <h3 class="patients-container--sections">
                  Sekretariat Polskiego Towarzystwa Okulistycznego
                </h3>
                <div class="pt-3">
                  Katedra Okulistyki Wydziału Nauk Medycznych w Katowicach
                </div>
                <div>Śląski Uniwersytet Medyczny w Katowicach</div>
                <div class="pt-3">ul. Ceglana 35</div>
                <div>40-514 Katowice</div>
                <div class="pt-3">
                  tel.: 570 960 004
                </div>
              </v-flex>
              <v-flex
                xs12
                class="text-xs-left px-md-3 px-2"
                id="bulletsSection"
              >
                <div class="two-column">
                  <div class="single-col">
                    <div class="styled-input-container styled-input--rounded">
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted1"
                          v-validate="'required'"
                          data-vv-name="form.accepted1"
                          data-vv-as="zgody"
                          name="accepted"
                          id="checkbox3-example-one"
                        />
                        <label for="checkbox3-example-one">
                          Wyrażam zgodę na przetwarzanie przez firmę Compass
                          Public Relations s.c. K. Waligóra, A. Pawlikowska z
                          siedzibą w Warszawie przy ul. Chłodnej 64 lok. 223,
                          kod: 00-872 moich danych osobowych zawartych
                          w&nbsp;formularzu rejestracyjnym w&nbsp;celu
                          i&nbsp;zakresie niezbędnym do rejestracji na
                          wydarzenie organizowane przez firmę Compass Public
                          Relations s.c. K. Waligóra, A. Pawlikowska.
                          <br /><br />W związku z&nbsp;wejściem nowego
                          rozporządzenia Unii Europejskiej o&nbsp;ochronie
                          danych osobowych tzw. RODO wyrażam zgodę na
                          przetwarzanie moich danych osobowych zawartych
                          w&nbsp;niniejszym zgłoszeniu dla potrzeb niezbędnych
                          do informowania o&nbsp;Konferencjach i&nbsp;Zjazdach
                          organizowanych przez firmę Compass Public Relations
                          s.c. K. Waligóra, A. Pawlikowska z siedzibą w
                          Warszawie przy ul. Chłodnej 64 lok. 223, kod: 00-872
                          (zgodnie z&nbsp;Rozporządzeniem Parlamentu
                          Europejskiego i&nbsp;Rady (UE) 2016/679 - RODO/GDPR
                          z&nbsp;dnia 27 kwietnia 2016 roku, ustawy
                          o&nbsp;ochronie danych osobowych z&nbsp;dnia 10 maja
                          2018 r.).
                        </label>
                        <div class="v-messages__wrapper error--text">
                          <i
                            v-show="errors.has('form.accepted1')"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('form.accepted1')"
                            class="v-messages__message v-messages"
                            >{{ errors.first("form.accepted1") }}</span
                          >
                        </div>
                      </div>
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted2"
                          name="accepted2"
                          id="checkbox3-example-two"
                        />
                        <label for="checkbox3-example-two">
                          Wyrażam zgodę na przesyłanie mi informacji handlowych
                          środkami komunikacji elektronicznej przez: Polskie
                          Towarzystwo Okulistyczne z&nbsp;siedzibą
                          w&nbsp;Warszawie oraz podmioty współpracujące
                          w&nbsp;szczególności firmę Compass Public Relations
                          s.c. K. Waligóra, A. Pawlikowska z siedzibą w
                          Warszawie przy ul. Chłodnej 64 lok. 223, kod: 00-872,
                          zgodnie z&nbsp;ustawą z&nbsp;dnia 18 lipca
                          2002&nbsp;r. o&nbsp;świadczeniu usług drogą
                          elektroniczną (Dz.&nbsp;U. z&nbsp;2002&nbsp;r.
                          Nr&nbsp;144, poz. 1204 z&nbsp;późn. zm.). Wyrażam
                          zgodę na przetwarzanie moich danych osobowych przez
                          Polskie Towarzystwo Okulistyczne z&nbsp;siedzibą
                          w&nbsp;Warszawie w&nbsp;celach marketingowych oraz na
                          przekazywanie mi propozycji zawarcia umowy przy użyciu
                          telefonu zgodnie z&nbsp;Ustawą z&nbsp;dnia
                          16&nbsp;lipca 2004&nbsp;r. Prawo telekomunikacyjne
                          (tj. Dz.&nbsp;U. z&nbsp;2014&nbsp;r. poz. 243).
                          <br />Oświadczam, że zostałam(em) poinformowana(y)
                          o&nbsp;prawie wglądu do moich danych
                          i&nbsp;dokonywaniu ich zmian.
                        </label>
                      </div>
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted3"
                          v-validate="'required'"
                          data-vv-name="form.accepted3"
                          data-vv-as="zgody"
                          name="accepted3"
                          id="checkbox3-example-three"
                        />
                        <label for="checkbox3-example-three">
                          Akceptuję
                          <router-link
                            :to="{ name: 'Regulations' }"
                            class="doctors-container--links"
                            >regulamin.
                          </router-link>
                        </label>
                        <div class="v-messages__wrapper error--text">
                          <i
                            v-show="errors.has('form.accepted3')"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('form.accepted3')"
                            class="v-messages__message v-messages"
                            >{{ errors.first("form.accepted3") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container>
            <v-layout row class="mb-3" @click="submit">
              <v-flex class="xs12 sm6">
                <my-button
                  title="Wyślij wiadomość"
                  text="<span>Wyślij <br>wiadomość</span>"
                  customClass="doctor rect-x1"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-container>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3 class="doctors-container--sections">
              Dziękujemy za wiadomość.
            </h3>
            <h4>Twoja wiadomość została przekazana do organizatora.</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="header-separator" style="height: 50px"></div>
  </div>
</template>

<script>
import { storeDownload } from "@/services/Cookies";
import MyButton from "@/components/partials/Button";
import DoctorHeader from "@/components/partials/DoctorHeader";
import Countdown from "@/components/partials/Countdown";
import VueScrollTo from "vue-scrollto";
import moment from "moment";
import SponsorsOnlySlider from "./partials/SponsorsOnlySlider";

export default {
  data() {
    return {
      institutions_number: "",
      cities_number: "",
      states_number: "",
      patients_number: "",
      institutions_number_now: "",
      cities_number_now: "",
      states_number_now: "",
      patients_number_now: "",
      hover: false,
      stream: false,
      hideTimer: false,
      isDownload: true,
      dialog: false,
      valid: true,
      time: null,
      form: [
        {
          id: "first_name",
          model: "first_name",
          type: "text",
          name: "first_name",
        },
        { id: "phone", model: "phone", type: "text", name: "phone" },
        { id: "email", model: "email", type: "text", name: "email" },
        { id: "message", model: "message", type: "text", name: "comment" },
      ],
      nameRules: [(v) => !!v || "Pole jest wymagane"],
      emailRules: [
        (v) => !!v || "E-mail jest wymagany",
        (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            v
          ) || "Zły format",
      ],
    };
  },
  components: {
    DoctorHeader,
    Countdown,
    MyButton,
    moment,
    SponsorsOnlySlider,
  },
  watch: {
    $route: function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      }
    },
  },
  mounted() {
    this.fetchTime();
    if (this.$route.hash) {
      this.scrollToSection(this.$route.hash);
    }
  },
  beforeMount() {
    this.fetchInstitutions();
    this.fetchCities();
    this.fetchPatients();
    this.fetchStates();
    this.fetchInstitutionsNow();
    this.fetchCitiesNow();
    this.fetchPatientsNow();
    this.fetchStatesNow();
  },
  methods: {
    isRegisterButtonShown() {
      const showDate = "2021-03-01 00:00:00";

      if (moment().isBefore(showDate)) {
        return true;
      }
      return false;
    },
    fetchInstitutions() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-institutions`,
      }).then((result) => {
        this.institutions_number = result.data;
      });
    },
    fetchStates() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-states`,
      }).then((result) => {
        this.states_number = result.data;
      });
    },
    fetchCities() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-cities`,
      }).then((result) => {
        this.cities_number = result.data;
      });
    },
    fetchPatients() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-patients`,
      }).then((result) => {
        this.patients_number = result.data;
      });
    },
    fetchInstitutionsNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-institutions-now`,
      }).then((result) => {
        this.institutions_number_now = result.data;
      });
    },
    fetchStatesNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-states-now`,
      }).then((result) => {
        this.states_number_now = result.data;
      });
    },
    fetchCitiesNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-cities-now`,
      }).then((result) => {
        this.cities_number_now = result.data;
      });
    },
    fetchPatientsNow() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-patients-now`,
      }).then((result) => {
        this.patients_number_now = result.data;
      });
    },
    showForum() {
      const dateToCheck = "2020-01-15 00:00:00";
      if (moment().isAfter(dateToCheck)) {
        return true;
      }
    },
    showForumCast() {
      const dateToCheck = "2019-03-07 00:00:00";
      if (moment().isAfter(dateToCheck)) {
        return true;
      }
    },
    storeDownloadItem(value) {
      const token = window.localStorage.getItem("wgwtoken");
      console.log(token);
      storeDownload({ token, value });
    },
    scrollToSection(section) {
      const options = {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: -200,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true,
      };

      VueScrollTo.scrollTo(section, 300, options);
    },
    goRegister() {
      this.$router.push({
        name: "Register",
      });
    },
    fetchTime() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/time`,
      }).then((response) => {
        this.time = response.data[0].dateToCheck;
      });
    },
    clearForm() {
      this.form.name = "";
      this.form.phone = "";
      this.form.email = "";
      this.form.message = "";
      this.form.accepted1 = null;
      this.form.accepted2 = null;
      this.form.accepted3 = null;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.isDisabled = true;
            const data = {
              form: {
                name: this.form.name,
                email: this.form.email,
                phone: this.form.phone,
                message: this.form.message,
                accepted1: this.form.accepted1,
                accepted2: this.form.accepted2,
                accepted3: this.form.accepted3,
              },
            };

            this.clearForm();
            this.$refs.form.reset();

            this.axios({
              method: "POST",
              url: `${process.env.APP_URL}/api/send`,
              data,
            })
              .then((response) => {
                this.isDisabled = false;

                this.clearForm();
                this.$refs.form.reset();

                this.dialog = true;
              })
              .catch((response) => {
                this.isDisabled = false;
                Object.keys(response.response.data.errors).map((key) =>
                  response.response.data.errors[key].map((error) =>
                    this.showErrors(error)
                  )
                );
              });
          } else {
            this.scrollToSection("#bulletsSection");
          }
        });
      } else {
        this.scrollToSection("#contactSection");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.term-container--position {
  align-items: baseline !important;
}

.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}

.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}

.banner {
  background-color: transparent;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: "Fira Sans", sans-serif;
  text-align: left;
  color: #aaa;
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  align-items: center;
}

.banner img {
  float: left;
}

.time-container {
  display: inline-flex;
  width: 100%;
}

.time-container--separator {
  width: 145px;
  padding-right: 5px;
}

.doctors-container--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}

.doctors-container--header {
  color: rgb(164, 22, 17);
}

.doctors-container--links {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
}

.doctors-container--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}

.doctors-container--sections-brown {
  color: #a41611;
}

.doctors-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}

.doctors-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border: none;
  padding: 20px;
}

.doctors-container--icons-brown {
  background: #a82824;
}

.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}

.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}

.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}

.register-bg {
  position: relative;
}

.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: fixed;
  opacity: 0.1;
  background-image: url("./../assets/images/register-bg.png");
  background-repeat: repeat;
  background-position: center center;
}

.doctor-header {
  background: #a82824;
  opacity: 0.9;
}

.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}

.free-main-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 12px;
}

.main-header--wgw {
  width: 125px;
}

.main-header--pto {
  width: 90px;
}

.patients-container--sections {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}

@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }

  .main-header--pto {
    width: 200px;
  }
}

.main-header--free {
  width: 280px;
}

.button-container-blue {
  background: #275271;
  opacity: 0.9;
  cursor: pointer;
}

.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}

.button-container--register {
  font-family: "Fira Sans", sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}

.doctor-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}

.button-container--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}

.button-container--arrow {
  margin-right: 20px;
}

.free-main-header--margin {
  margin-top: 100px;
}

.button-container--margin {
  margin-bottom: 30px;
}

.button-container--padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}

.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}

.doctors-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
}

.doctors-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}

@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px;
  }

  .button-container--text {
    font-size: 26px;
  }
}

.register-form--noShadow {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.patients-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.patients-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Doctors.vue